// Day 7 - Full Production Content (PREMIUM)
// Temat: Research i analiza z AI
// Ton: analityczny, praktyczny, premium
// Duration: 12-15 minutes

export const day7Content = {
  day_number: 7,
  title: "Research i analiza z AI",
  subtitle: "Zbieranie i przetwarzanie informacji",
  duration: "12-15 min",
  is_premium: true,
  has_ai_coach: true,
  exercises: [
    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 1: AI jako asystent research (5 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d7_ex1",
      title: "AI jako asystent research",
      icon: "search",
      steps: [
        {
          id: "d7_ex1_s1",
          type: "choice",
          title: "Mocne strony AI w research",
          content: "W czym AI jest najlepsze przy zbieraniu informacji?",
          options: [
            { id: "a", text: "Zawsze ma aktualne dane", correct: false },
            { id: "b", text: "Szybka synteza dużych ilości informacji i identyfikacja wzorców", correct: true },
            { id: "c", text: "Dostęp do tajnych źródeł", correct: false },
            { id: "d", text: "100% dokładność", correct: false }
          ],
          shuffle: true,
          softHint: "AI przetwarza i syntezuje informacje szybciej niż człowiek.",
          successMessage: "Tak! Synteza i wzorce – to jest siła AI w research."
        },
        {
          id: "d7_ex1_s2",
          type: "choice",
          title: "Ograniczenia AI",
          content: "Jakie jest główne ograniczenie AI w research?",
          options: [
            { id: "a", text: "Nie rozumie pytań", correct: false },
            { id: "b", text: "Może mieć nieaktualne dane i 'halucynować' (zmyślać fakty)", correct: true },
            { id: "c", text: "Jest za wolne", correct: false },
            { id: "d", text: "Nie ma ograniczeń", correct: false }
          ],
          shuffle: true,
          softHint: "AI nie zawsze wie, że nie wie – może generować przekonująco brzmiące nieprawdy.",
          successMessage: "Dokładnie! Weryfikuj fakty z AI – może halucynować."
        },
        {
          id: "d7_ex1_s3",
          type: "choice",
          title: "Strategia weryfikacji",
          content: "Jak weryfikować informacje od AI?",
          options: [
            { id: "a", text: "Wierzyć wszystkiemu, AI jest dokładne", correct: false },
            { id: "b", text: "Prosić o źródła, sprawdzać kluczowe fakty, krzyżowo weryfikować", correct: true },
            { id: "c", text: "Nigdy nie używać AI do research", correct: false },
            { id: "d", text: "Weryfikować tylko gdy wygląda podejrzanie", correct: false }
          ],
          shuffle: true,
          softHint: "Zasada: im ważniejsza informacja, tym dokładniejsza weryfikacja.",
          successMessage: "Tak! Źródła + weryfikacja = wiarygodny research."
        },
        {
          id: "d7_ex1_s4",
          type: "choice",
          title: "Kiedy AI, kiedy tradycyjnie?",
          content: "Kiedy lepiej użyć tradycyjnego research zamiast AI?",
          options: [
            { id: "a", text: "Nigdy, AI zawsze lepsze", correct: false },
            { id: "b", text: "Dla aktualnych danych, specjalistycznych źródeł, weryfikowalnych faktów", correct: true },
            { id: "c", text: "Dla wszystkiego", correct: false },
            { id: "d", text: "Tylko gdy AI nie działa", correct: false }
          ],
          shuffle: true,
          softHint: "AI dla syntezy, tradycyjne źródła dla aktualności i dokładności.",
          successMessage: "Właśnie! Łącz AI z tradycyjnymi źródłami dla najlepszych wyników."
        },
        {
          id: "d7_ex1_s5",
          type: "fill",
          title: "Złota zasada research",
          content: "Dokończ zdanie:",
          template: "Im ważniejsza decyzja, tym więcej _______ potrzebuję.",
          correctAnswers: ["weryfikacji", "źródeł", "sprawdzenia", "potwierdzenia", "dowodów"],
          minLength: 5,
          softHint: "Ważne decyzje wymagają solidnych podstaw.",
          successMessage: "Dokładnie! Ważność decyzji = poziom weryfikacji."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 2: Techniki research z AI (6 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d7_ex2",
      title: "Techniki research",
      icon: "layers",
      steps: [
        {
          id: "d7_ex2_s1",
          type: "choice",
          title: "Technika: Strukturyzacja pytań",
          content: "Jak zadawać pytania research-owe AI?",
          options: [
            { id: "a", text: "Ogólnie: 'Powiedz mi o X'", correct: false },
            { id: "b", text: "Konkretnie: 'Podaj 5 głównych trendów w X z ostatnich 2 lat'", correct: true },
            { id: "c", text: "Krótko: 'X?'", correct: false },
            { id: "d", text: "Nie ma znaczenia jak", correct: false }
          ],
          shuffle: true,
          softHint: "Konkretne pytania = konkretne odpowiedzi.",
          successMessage: "Tak! Specyficzność pytania determinuje jakość odpowiedzi."
        },
        {
          id: "d7_ex2_s2",
          type: "choice",
          title: "Technika: Wielopoziomowe drążenie",
          content: "Jak głęboko eksplorować temat z AI?",
          options: [
            { id: "a", text: "Jeden prompt i koniec", correct: false },
            { id: "b", text: "Pytanie ogólne → follow-up na szczegóły → drążenie wątków", correct: true },
            { id: "c", text: "Pytać o wszystko na raz", correct: false },
            { id: "d", text: "Zadawać identyczne pytania", correct: false }
          ],
          shuffle: true,
          softHint: "Drąż głębiej: ogólne → szczegółowe → jeszcze głębiej.",
          successMessage: "Właśnie! Drążenie: overview → szczegóły → deep dive."
        },
        {
          id: "d7_ex2_s3",
          type: "shortPrompt",
          title: "Prompt research-owy",
          content: "Napisz prompt do zbadania trendu 'AI w edukacji' z prośbą o strukturę:",
          placeholder: "Przeanalizuj trend AI w edukacji...",
          minLength: 70,
          requiredElements: ["AI|sztuczn", "edukacj|nauk|szkoł", "trend|rozwój|analiz"],
          softHint: "Określ: zakres, głębokość, format wyjścia (np. lista, sekcje).",
          successMessage: "Świetny prompt research-owy! Dobra struktura = lepsze wyniki."
        },
        {
          id: "d7_ex2_s4",
          type: "choice",
          title: "Technika: Porównania",
          content: "Jak AI może pomóc w analizie porównawczej?",
          options: [
            { id: "a", text: "Nie może porównywać", correct: false },
            { id: "b", text: "Tworząc tabele porównawcze, zestawienia za/przeciw, benchmarki", correct: true },
            { id: "c", text: "Tylko tekst bez struktury", correct: false },
            { id: "d", text: "Kopiując z internetu", correct: false }
          ],
          shuffle: true,
          softHint: "AI świetnie strukturyzuje porównania – poproś o tabelę/zestawienie.",
          successMessage: "Tak! Tabele, matryce, benchmarki – AI świetnie to robi."
        },
        {
          id: "d7_ex2_s5",
          type: "choice",
          title: "Technika: Synteza wielu źródeł",
          content: "Jak poprosić AI o syntezę informacji?",
          options: [
            { id: "a", text: "Wklejać całe dokumenty bez instrukcji", correct: false },
            { id: "b", text: "Podać kontekst, poprosić o kluczowe wnioski i wzorce", correct: true },
            { id: "c", text: "Zadać krótkie pytanie", correct: false },
            { id: "d", text: "Prosić o kopię tekstu", correct: false }
          ],
          shuffle: true,
          softHint: "Synteza = wyciągnięcie esencji, nie kopiowanie.",
          successMessage: "Dokładnie! 'Wyciągnij kluczowe wnioski z...' = dobra synteza."
        },
        {
          id: "d7_ex2_s6",
          type: "reorder",
          title: "Proces research z AI",
          content: "Ułóż etapy research z AI:",
          items: [
            { id: "r1", text: "Zdefiniuj pytanie badawcze", order: 1 },
            { id: "r2", text: "Zbierz overview tematu od AI", order: 2 },
            { id: "r3", text: "Drąż szczegóły w interesujących obszarach", order: 3 },
            { id: "r4", text: "Weryfikuj kluczowe fakty z zewnętrznych źródeł", order: 4 },
            { id: "r5", text: "Syntezuj wnioski", order: 5 }
          ],
          softHint: "Pytanie → overview → szczegóły → weryfikacja → synteza",
          successMessage: "To jest profesjonalny proces research!"
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 3: Analiza danych z AI (5 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d7_ex3",
      title: "Analiza danych i trendów",
      icon: "target",
      steps: [
        {
          id: "d7_ex3_s1",
          type: "choice",
          title: "AI w analizie danych",
          content: "Jak AI może pomóc w analizie danych tekstowych?",
          options: [
            { id: "a", text: "Tylko liczyć słowa", correct: false },
            { id: "b", text: "Identyfikować wzorce, sentiment, tematy, anomalie", correct: true },
            { id: "c", text: "Nie może analizować danych", correct: false },
            { id: "d", text: "Tylko tworzyć wykresy", correct: false }
          ],
          shuffle: true,
          softHint: "AI rozumie kontekst i może wyciągać insights z tekstu.",
          successMessage: "Tak! Wzorce, sentiment, tematy – AI widzi to w tekście."
        },
        {
          id: "d7_ex3_s2",
          type: "choice",
          title: "Analiza sentymentu",
          content: "Do czego służy analiza sentymentu?",
          options: [
            { id: "a", text: "Liczenie zdań", correct: false },
            { id: "b", text: "Określanie emocjonalnego tonu (pozytywny/negatywny/neutralny)", correct: true },
            { id: "c", text: "Tłumaczenie tekstu", correct: false },
            { id: "d", text: "Sprawdzanie gramatyki", correct: false }
          ],
          shuffle: true,
          softHint: "Sentiment = nastrój/ton emocjonalny tekstu.",
          successMessage: "Dokładnie! Sentiment analysis = ton emocjonalny tekstu."
        },
        {
          id: "d7_ex3_s3",
          type: "shortPrompt",
          title: "Prompt analityczny",
          content: "Napisz prompt do analizy 50 opinii klientów, prosząc o: tematy, sentiment, rekomendacje:",
          placeholder: "Przeanalizuj poniższe opinie klientów...",
          minLength: 80,
          requiredElements: ["analiz|przeanalizuj", "opini|feedback|komentarz", "temat|wzorce|sentiment|rekomend"],
          softHint: "Określ co chcesz: tematy, sentiment, wzorce, rekomendacje.",
          successMessage: "Świetny prompt analityczny! Jasne oczekiwania = dobre wyniki."
        },
        {
          id: "d7_ex3_s4",
          type: "choice",
          title: "Wykrywanie wzorców",
          content: "Jak poprosić AI o wykrycie wzorców?",
          options: [
            { id: "a", text: "\"Znajdź wzorce\"", correct: false },
            { id: "b", text: "\"Zidentyfikuj powtarzające się tematy, trendy i anomalie w danych\"", correct: true },
            { id: "c", text: "\"Czy są wzorce?\"", correct: false },
            { id: "d", text: "\"Policz dane\"", correct: false }
          ],
          shuffle: true,
          softHint: "Konkretyzuj: jakich wzorców szukasz (tematy, trendy, anomalie)?",
          successMessage: "Tak! Specyficzność: powtarzające się X, trendy w Y, anomalie."
        },
        {
          id: "d7_ex3_s5",
          type: "classify",
          title: "Rodzaje analiz",
          content: "Przyporządkuj typ analizy do sytuacji:",
          categories: ["Sentiment analysis", "Analiza tematów", "Wykrywanie anomalii"],
          items: [
            { id: "c1", text: "Czy klienci są zadowoleni?", category: "Sentiment analysis" },
            { id: "c2", text: "O czym najczęściej piszą klienci?", category: "Analiza tematów" },
            { id: "c3", text: "Czy są nietypowe skargi?", category: "Wykrywanie anomalii" },
            { id: "c4", text: "Jaki jest ton recenzji?", category: "Sentiment analysis" },
            { id: "c5", text: "Główne problemy produktu?", category: "Analiza tematów" },
            { id: "c6", text: "Nagły skok negatywnych opinii?", category: "Wykrywanie anomalii" }
          ],
          softHint: "Sentiment = emocje, Tematy = co, Anomalie = nietypowe.",
          successMessage: "Świetnie! Dopasowujesz typ analizy do pytania."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 4: Raportowanie i prezentacja (5 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d7_ex4",
      title: "Raportowanie wyników",
      icon: "edit",
      steps: [
        {
          id: "d7_ex4_s1",
          type: "choice",
          title: "Od danych do raportu",
          content: "Jak AI może pomóc w tworzeniu raportów?",
          options: [
            { id: "a", text: "Tylko formatować tekst", correct: false },
            { id: "b", text: "Strukturyzować dane, pisać executive summary, tworzyć wnioski", correct: true },
            { id: "c", text: "Nie może pomagać w raportach", correct: false },
            { id: "d", text: "Tylko tłumaczyć", correct: false }
          ],
          shuffle: true,
          softHint: "AI świetnie strukturyzuje i syntezuje – idealne do raportów.",
          successMessage: "Tak! Struktura, synteza, wnioski – AI pomaga na każdym etapie."
        },
        {
          id: "d7_ex4_s2",
          type: "choice",
          title: "Executive Summary",
          content: "Czym jest dobre executive summary?",
          options: [
            { id: "a", text: "Skróconą wersją całego raportu", correct: false },
            { id: "b", text: "Kluczowe wnioski i rekomendacje dla decydentów (1 strona max)", correct: true },
            { id: "c", text: "Wprowadzeniem do raportu", correct: false },
            { id: "d", text: "Spisem treści", correct: false }
          ],
          shuffle: true,
          softHint: "Executive summary = esencja dla osób podejmujących decyzje.",
          successMessage: "Dokładnie! Wnioski + rekomendacje + max 1 strona."
        },
        {
          id: "d7_ex4_s3",
          type: "shortPrompt",
          title: "Prompt na executive summary",
          content: "Napisz prompt do stworzenia executive summary z raportu o sprzedaży:",
          placeholder: "Na podstawie poniższych danych, stwórz executive summary...",
          minLength: 70,
          requiredElements: ["executive|podsumowan|streszczen", "kluczow|główn|wnios|rekomend", "sprzedaż|dane|raport"],
          softHint: "Poproś o: kluczowe wnioski, liczby, rekomendacje, max długość.",
          successMessage: "Świetny prompt na executive summary!"
        },
        {
          id: "d7_ex4_s4",
          type: "choice",
          title: "Wizualizacja słowna",
          content: "Jak AI może pomóc w opisie danych bez wykresów?",
          options: [
            { id: "a", text: "Nie może – potrzebne wykresy", correct: false },
            { id: "b", text: "Tworząc słowne porównania, proporcje, trendy w formie tekstu", correct: true },
            { id: "c", text: "Tylko tabele", correct: false },
            { id: "d", text: "Kopiując liczby", correct: false }
          ],
          shuffle: true,
          softHint: "'Wzrost o 50%', '3 na 4 respondentów...' – liczby w kontekście.",
          successMessage: "Tak! Słowna wizualizacja: liczby w kontekście, porównania, proporcje."
        },
        {
          id: "d7_ex4_s5",
          type: "reorder",
          title: "Struktura raportu",
          content: "Ułóż typową strukturę raportu analitycznego:",
          items: [
            { id: "r1", text: "Executive Summary", order: 1 },
            { id: "r2", text: "Kontekst i metodologia", order: 2 },
            { id: "r3", text: "Kluczowe wyniki", order: 3 },
            { id: "r4", text: "Szczegółowa analiza", order: 4 },
            { id: "r5", text: "Wnioski i rekomendacje", order: 5 }
          ],
          softHint: "Od ogółu do szczegółu, zakończ wnioskami.",
          successMessage: "To jest profesjonalna struktura raportu!"
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 5: Podsumowanie tygodnia (4 kroki)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d7_ex5",
      title: "Podsumowanie tygodnia",
      icon: "trophy",
      steps: [
        {
          id: "d7_ex5_s1",
          type: "choice",
          title: "Quiz: Research z AI",
          content: "Najważniejsza zasada research z AI to:",
          options: [
            { id: "a", text: "Wierzyć wszystkiemu co powie AI", correct: false },
            { id: "b", text: "Weryfikować kluczowe fakty z zewnętrznych źródeł", correct: true },
            { id: "c", text: "Używać AI tylko do prostych pytań", correct: false },
            { id: "d", text: "Nie używać AI do research", correct: false }
          ],
          shuffle: true,
          softHint: "Zaufaj, ale weryfikuj – AI może halucynować.",
          successMessage: "Tak! Weryfikacja = wiarygodność."
        },
        {
          id: "d7_ex5_s2",
          type: "choice",
          title: "Quiz: Analiza danych",
          content: "AI jest najlepsze w:",
          options: [
            { id: "a", text: "Zbieraniu aktualnych danych", correct: false },
            { id: "b", text: "Syntezie, wzorcach, strukturyzacji dużych ilości tekstu", correct: true },
            { id: "c", text: "Tworzeniu wykresów", correct: false },
            { id: "d", text: "Liczeniu", correct: false }
          ],
          shuffle: true,
          softHint: "Synteza i wzorce – to jest siła AI.",
          successMessage: "Dokładnie! Synteza, wzorce, struktura – tu AI błyszczy."
        },
        {
          id: "d7_ex5_s3",
          type: "choice",
          title: "Podsumowanie tygodnia",
          content: "W tym tygodniu nauczyłeś się:",
          options: [
            { id: "a", text: "Tylko podstaw AI", correct: false },
            { id: "b", text: "AI Coacha, automatyzacji, kreatywności, research i analizy z AI!", correct: true },
            { id: "c", text: "Niczego nowego", correct: false },
            { id: "d", text: "Tylko jednej techniki", correct: false }
          ],
          shuffle: true,
          softHint: "Przejrzyjmy: Day 4 (AI Coach), Day 5 (automatyzacja), Day 6 (kreatywność), Day 7 (research).",
          successMessage: "Świetny tydzień! Masz teraz solidne fundamenty pracy z AI."
        },
        {
          id: "d7_ex5_s4",
          type: "choice",
          title: "Tydzień 1 ukończony!",
          content: "Gratulacje! Ukończyłeś pierwszy pełny tydzień. Co dalej?",
          options: [
            { id: "a", text: "Wróć do listy lekcji i kontynuuj", isChoice: true },
            { id: "b", text: "Wypróbuj AI Coacha dla podsumowania", isChoice: true }
          ],
          shuffle: false,
          softHint: "Wybierz swoją ścieżkę!",
          successMessage: "Tydzień 1 za Tobą! Jesteś teraz kompetentnym użytkownikiem AI. Od jutra: zaawansowane techniki!"
        }
      ]
    }
  ]
};

export default day7Content;
